import { Box, IconButton, Tooltip } from "@mui/material";
import { Download } from "@mui/icons-material";
import { useDownloadDataChunksCSV } from "../../services/DataChunkServices";

interface SourcesDownloadButtonProps {
  responseSources: any[];
}

const SourcesDownloadButton = ({
  responseSources,
}: SourcesDownloadButtonProps) => {
  const { mutate: downloadDataChunks, isLoading: isDownloading } =
    useDownloadDataChunksCSV();

  const handleDownloadCSV = () => {
    const dataChunkIds = responseSources
      .map((source) => source.data_chunk?.id)
      .filter((id): id is number => typeof id === "number");

    downloadDataChunks(dataChunkIds);
  };

  return (
    <Tooltip
      title={`Download ${responseSources.length} sources as CSV`}
      disableHoverListener={!responseSources.length}
    >
      <Box component="span">
        <IconButton
          onClick={handleDownloadCSV}
          size="small"
          sx={{ mr: 1 }}
          disabled={!responseSources.length || isDownloading}
          data-attr="assistant:btn:download-sources-csv"
        >
          <Download
            fontSize="small"
            color={isDownloading ? "disabled" : "inherit"}
          />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default SourcesDownloadButton;
